module.exports = __webpack_public_path__ + "img/a2_1.e40ec458.jpg";